"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Icon = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var _IconStyled = require("./IconStyled");
/**
 * A general-purpose component that allows users to wrap their own icons in a reasonable container.
 */
const Icon = /*#__PURE__*/(0, _react.forwardRef)((_ref, ref) => {
  let {
    dangerouslySetSvg,
    size,
    "aria-hidden": ariaHidden = true,
    role = "presentation",
    clientId,
    children,
    ...props
  } = _ref;
  if (process.env.NODE_ENV !== "production") {
    const renderableProps = [children ? "children" : null, dangerouslySetSvg ? "dangerouslySetSvg" : null].filter(Boolean);
    if (renderableProps.length === 0) {
      console.warn(`Icon: you must pass one of children or dangerouslySetSvg at least.`);
    }
    if (renderableProps.length > 1) {
      console.warn(`Icon: please pass only one of children or dangerouslySetSvg, got [${renderableProps.join(", ")}]`);
    }
  }
  const height = resolveSize(size, "height");
  const width = resolveSize(size, "width");
  const sharedProps = {
    "aria-hidden": ariaHidden,
    "data-client-id": clientId,
    ref,
    role,
    height,
    width,
    ...props
  };
  if (dangerouslySetSvg) {
    return /*#__PURE__*/_react.default.createElement(_IconStyled.IconStyled, (0, _extends2.default)({}, sharedProps, {
      dangerouslySetInnerHTML: {
        __html: dangerouslySetSvg
      }
    }));
  } else if (children) {
    return /*#__PURE__*/_react.default.createElement(_IconStyled.IconStyled, sharedProps, children);
  }
  return null;
});
exports.Icon = Icon;
Icon.displayName = "Icon";
function resolveSize(size, which) {
  if (typeof size === "number") {
    return `${size}px`;
  } else if (typeof size[which] === "string") {
    return size[which];
  } else {
    return `${size[which]}px`;
  }
}
//# sourceMappingURL=Icon.js.map